import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  token: null,
  company: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,
};

// Create slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.token = action.payload.token;
      state.company = action.payload.company;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
    },
    clearAuth: (state) => {
      state.token = null;
      state.company = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

// Async actions
export const saveAuthToStorage = (authData) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    localStorage.setItem('company', JSON.stringify(authData));
    localStorage.setItem('token', authData.token);
    dispatch(setAuth(authData));
  } catch (error) {
    dispatch(setError(error.message || 'Failed to save auth data'));
  }
};

export const loadAuthFromStorage = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const authData = localStorage.getItem('company');
    if (authData) {
      dispatch(setAuth(JSON.parse(authData)));
    } else {
      dispatch(clearAuth());
    }
  } catch (error) {
    dispatch(setError(error.message || 'Failed to load auth data'));
  } finally {
    dispatch(setLoading(false));
  }
};

export const logout = () => async (dispatch) => {
  try {
    localStorage.removeItem('company');
    localStorage.removeItem('token');
    dispatch(clearAuth());
  } catch (error) {
    dispatch(setError(error.message || 'Failed to logout'));
  }
};

// Export actions
export const { setAuth, clearAuth, setLoading, setError } = authSlice.actions;

// Selectors
export const selectCurrentCompany = (state) => state.auth.company;
export const selectCurrentToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.isLoading;
export const selectAuthError = (state) => state.auth.error;

// Export reducer
export default authSlice.reducer;